import { render, staticRenderFns } from "./withdrawDeposit.vue?vue&type=template&id=679678db&scoped=true"
import script from "./withdrawDeposit.vue?vue&type=script&lang=js"
export * from "./withdrawDeposit.vue?vue&type=script&lang=js"
import style0 from "./withdrawDeposit.vue?vue&type=style&index=0&id=679678db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679678db",
  null
  
)

export default component.exports